// ============================================================================
// ConfirmReceiveParcel — Mock data store (prototype)
// ----------------------------------------------------------------------------
// ຍັງບໍ່ມີ backend API ສຳລັບໜ້ານີ້ — ຈຶ່ງເຮັດເປັນ mock data ກ່ອນ.
// State ຖືກເກັບໄວ້ໃນ localStorage ເພື່ອໃຫ້ການຢືນຢັນ/ປະຕິເສດ ຄົງຢູ່ຫຼັງ reload.
//
// ເມື່ອ backend ພ້ອມ: ປ່ຽນ DEMO_ENABLED = false ແລ້ວ wire component ໄປ API ຈິງ
// (ເບິ່ງ fetchItem() ໃນ ListConfirmReceiveParcel.vue — ມີຈຸດ hook ໄວ້ໃຫ້ແລ້ວ).
// ============================================================================

export const DEMO_ENABLED = true;

export const STORE_KEY = "confirm_receive_parcel_demo_v1";

// ---------------------------------------------------------------------------
// ສະຖານະ
// ---------------------------------------------------------------------------
export const RECEIVE_STATUSES = [
  { id: "pending", name: "ລໍຖ້າຢືນຢັນ", cls: "st-pending", icon: "fal fa-clock" },
  { id: "checking", name: "ກຳລັງກວດສອບ", cls: "st-checking", icon: "fal fa-search" },
  { id: "confirmed", name: "ຢືນຢັນຮັບແລ້ວ", cls: "st-confirmed", icon: "fal fa-check-circle" },
  { id: "rejected", name: "ປະຕິເສດຮັບ", cls: "st-rejected", icon: "fal fa-times-circle" },
];

export function getStatusMeta(id) {
  return RECEIVE_STATUSES.find((s) => s.id === id) || { id, name: "—", cls: "st-pending", icon: "fal fa-circle" };
}

export function getReceiveStatuses() {
  return RECEIVE_STATUSES.map((s) => ({ ...s }));
}

// ---------------------------------------------------------------------------
// ຮູບພາບຕົວຢ່າງ — ສ້າງເປັນ SVG data-uri ເພື່ອບໍ່ຕ້ອງເອີ້ນ network
// (ເມື່ອຕໍ່ API ຈິງ ໃຫ້ແທນທີ່ດ້ວຍ image_url ຈາກ server ໄດ້ເລີຍ)
// ---------------------------------------------------------------------------
function photo(label, bg, accent) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600">
    <rect width="800" height="600" fill="${bg}"/>
    <g transform="translate(400,270)">
      <rect x="-150" y="-100" width="300" height="200" rx="10" fill="${accent}" opacity="0.95"/>
      <rect x="-150" y="-100" width="300" height="46" rx="10" fill="#ffffff" opacity="0.25"/>
      <rect x="-26" y="-100" width="52" height="200" fill="#ffffff" opacity="0.35"/>
      <rect x="-110" y="20" width="120" height="52" rx="4" fill="#ffffff" opacity="0.85"/>
      <rect x="-102" y="30" width="104" height="6" fill="${bg}" opacity="0.6"/>
      <rect x="-102" y="42" width="76" height="6" fill="${bg}" opacity="0.6"/>
      <rect x="-102" y="54" width="92" height="6" fill="${bg}" opacity="0.6"/>
    </g>
    <text x="400" y="470" font-family="Arial, sans-serif" font-size="34" font-weight="bold"
          fill="#ffffff" text-anchor="middle">${label}</text>
  </svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

function photoSet(billNo) {
  return [
    { id: 1, caption: "ຮູບກ່ອງພັດສະດຸ (ດ້ານໜ້າ)", image_url: photo(billNo, "#2d6cdf", "#8b5a2b") },
    { id: 2, caption: "ຮູບປ້າຍເລກບິນ", image_url: photo(billNo + " • LABEL", "#0f9d58", "#a9743f") },
    { id: 3, caption: "ຮູບຕອນມອບ-ຮັບ", image_url: photo(billNo + " • HANDOVER", "#e07b16", "#7d5230") },
  ];
}

// ---------------------------------------------------------------------------
// seed data
// ---------------------------------------------------------------------------
function seed() {
  const raw = [
    {
      id: 8001, parcel_number: "HAL2026000101", status: "pending",
      created_at: "2026-08-11T08:20:00",
      start_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      end_branch: { name: "ສະຫວັນນະເຂດ", province: { prefix: "SVK" } },
      receiver: { name: "ສຸພາ ວົງສະຫວັນ", tel: "+856 20 5555 1111" },
      parcel: { category: "ເຄື່ອງໃຊ້ໄຟຟ້າ", weight: 4.5, quantity: 1, cod: 1500000 },
      remark: "ລູກຄ້າຂໍໃຫ້ຖ່າຍຮູບກ່ອງກ່ອນມອບ",
    },
    {
      id: 8002, parcel_number: "HAL2026000102", status: "confirmed",
      created_at: "2026-08-10T14:05:00",
      confirmed_at: "2026-08-10T16:40:00", confirmed_by: { name: "ພະນັກງານ ສາຂາປາກເຊ" },
      start_branch: { name: "ປາກເຊ", province: { prefix: "PSE" } },
      end_branch: { name: "ຫຼວງພະບາງ", province: { prefix: "LPB" } },
      receiver: { name: "ບຸນມີ ສຸວັນນະ", tel: "+856 20 5555 2222" },
      parcel: { category: "ເຄື່ອງນຸ່ງ", weight: 2.1, quantity: 3, cod: 800000 },
      remark: "",
    },
    {
      id: 8003, parcel_number: "HAL2026000103", status: "checking",
      created_at: "2026-08-10T09:15:00",
      start_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      end_branch: { name: "ຄຳມ່ວນ", province: { prefix: "KMN" } },
      receiver: { name: "ຄຳພອນ ແສງສະຫວ່າງ", tel: "+856 20 5555 3333" },
      parcel: { category: "ເຄື່ອງໃຊ້ໄຟຟ້າ", weight: 12.0, quantity: 1, cod: 2500000 },
      remark: "ກ່ອງມີຮອຍບຸບ — ກຳລັງກວດສອບກັບຕົ້ນທາງ",
    },
    {
      id: 8004, parcel_number: "HAL2026000104", status: "rejected",
      created_at: "2026-08-09T11:30:00",
      rejected_at: "2026-08-09T15:10:00", confirmed_by: { name: "ພະນັກງານ ສາຂາຫຼວງນ້ຳທາ" },
      reject_reason: "ເລກພັດສະດຸບໍ່ກົງກັບໃບບິນທີ່ສາຂາໄດ້ຮັບ",
      start_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      end_branch: { name: "ຫຼວງນ້ຳທາ", province: { prefix: "LNT" } },
      receiver: { name: "ມະນີ ສຸກສະຫວັນ", tel: "+856 20 5555 4444" },
      parcel: { category: "ສິນຄ້າທົ່ວໄປ", weight: 7.8, quantity: 2, cod: 0 },
      remark: "",
    },
    {
      id: 8005, parcel_number: "HAL2026000105", status: "pending",
      created_at: "2026-08-09T17:45:00",
      start_branch: { name: "ສະຫວັນນະເຂດ", province: { prefix: "SVK" } },
      end_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      receiver: { name: "ໄພບູນ ວົງສະຫວັນ", tel: "+856 20 5555 5555" },
      parcel: { category: "ອາຫານແຫ້ງ", weight: 1.2, quantity: 5, cod: 350000 },
      remark: "",
    },
    {
      id: 8006, parcel_number: "HAL2026000106", status: "confirmed",
      created_at: "2026-08-08T10:00:00",
      confirmed_at: "2026-08-08T13:22:00", confirmed_by: { name: "ພະນັກງານ ສາຂາບໍລິຄຳໄຊ" },
      start_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      end_branch: { name: "ບໍລິຄຳໄຊ", province: { prefix: "BLK" } },
      receiver: { name: "ສຸກສະຫວັນ ພົມມະວົງ", tel: "+856 20 5555 6666" },
      parcel: { category: "ເຄື່ອງໃຊ້ໄຟຟ້າ", weight: 9.4, quantity: 1, cod: 900000 },
      remark: "",
    },
    {
      id: 8007, parcel_number: "HAL2026000107", status: "pending",
      created_at: "2026-08-08T08:05:00",
      start_branch: { name: "ຫຼວງພະບາງ", province: { prefix: "LPB" } },
      end_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      receiver: { name: "ຈັນທະລາ ພິມມະສອນ", tel: "+856 20 5555 7777" },
      parcel: { category: "ເຄື່ອງສຳອາງ", weight: 0.8, quantity: 10, cod: 1200000 },
      remark: "",
    },
    {
      id: 8008, parcel_number: "HAL2026000108", status: "checking",
      created_at: "2026-08-07T16:20:00",
      start_branch: { name: "ຈຳປາສັກ", province: { prefix: "CPS" } },
      end_branch: { name: "ອັດຕະປື", province: { prefix: "ATP" } },
      receiver: { name: "ວັນນະສອນ ໄຊຍະວົງ", tel: "+856 20 5555 8888" },
      parcel: { category: "ອາໄຫຼ່ລົດ", weight: 22.5, quantity: 1, cod: 3200000 },
      remark: "ນ້ຳໜັກເກີນ — ລໍຖ້າຢືນຢັນຄ່າຂົນສົ່ງເພີ່ມ",
    },
    {
      id: 8009, parcel_number: "HAL2026000109", status: "confirmed",
      created_at: "2026-08-07T09:40:00",
      confirmed_at: "2026-08-07T11:05:00", confirmed_by: { name: "ພະນັກງານ ສາຂາຊຽງຂວາງ" },
      start_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      end_branch: { name: "ຊຽງຂວາງ", province: { prefix: "XKH" } },
      receiver: { name: "ທອງສຸກ ແກ້ວມະນີ", tel: "+856 20 5555 9999" },
      parcel: { category: "ເອກະສານ", weight: 0.3, quantity: 1, cod: 0 },
      remark: "",
    },
    {
      id: 8010, parcel_number: "HAL2026000110", status: "pending",
      created_at: "2026-08-06T13:15:00",
      start_branch: { name: "ອຸດົມໄຊ", province: { prefix: "ODX" } },
      end_branch: { name: "ຫຼວງນ້ຳທາ", province: { prefix: "LNT" } },
      receiver: { name: "ສົມພອນ ຈັນທະວົງ", tel: "+856 20 5555 1010" },
      parcel: { category: "ສິນຄ້າທົ່ວໄປ", weight: 5.6, quantity: 2, cod: 640000 },
      remark: "",
    },
    {
      id: 8011, parcel_number: "HAL2026000111", status: "rejected",
      created_at: "2026-08-06T08:50:00",
      rejected_at: "2026-08-06T10:30:00", confirmed_by: { name: "ພະນັກງານ ສາຂາຄຳມ່ວນ" },
      reject_reason: "ພັດສະດຸເສຍຫາຍ — ສົ່ງເຂົ້າຂັ້ນຕອນເຄື່ອງເສຍຫາຍແທນ",
      start_branch: { name: "ສະຫວັນນະເຂດ", province: { prefix: "SVK" } },
      end_branch: { name: "ຄຳມ່ວນ", province: { prefix: "KMN" } },
      receiver: { name: "ນາງ ດາລາ ສີສຸວັນ", tel: "+856 20 5555 1212" },
      parcel: { category: "ເຄື່ອງແກ້ວ", weight: 3.3, quantity: 1, cod: 450000 },
      remark: "",
    },
    {
      id: 8012, parcel_number: "HAL2026000112", status: "confirmed",
      created_at: "2026-08-05T15:25:00",
      confirmed_at: "2026-08-05T18:00:00", confirmed_by: { name: "ພະນັກງານ ສາຂາວຽງຈັນ" },
      start_branch: { name: "ບໍ່ແກ້ວ", province: { prefix: "BKO" } },
      end_branch: { name: "ວຽງຈັນ", province: { prefix: "VTE" } },
      receiver: { name: "ອຳພອນ ພັນທະວົງ", tel: "+856 20 5555 1313" },
      parcel: { category: "ເຄື່ອງນຸ່ງ", weight: 6.0, quantity: 4, cod: 980000 },
      remark: "",
    },
  ];

  return raw.map(normalize);
}

function normalize(item) {
  return {
    confirmed_at: null,
    rejected_at: null,
    confirmed_by: null,
    reject_reason: null,
    remark: "",
    ...item,
    images: item.images || photoSet(item.parcel_number),
  };
}

// ---------------------------------------------------------------------------
// store (localStorage-backed)
// ---------------------------------------------------------------------------
function save(list) {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(list));
  } catch (e) {
    /* ignore quota / privacy mode */
  }
}

function load() {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    }
  } catch (e) {
    /* ignore */
  }
  const data = seed();
  save(data);
  return data;
}

export function resetDemoStore() {
  const data = seed();
  save(data);
  return data;
}

// ---------------------------------------------------------------------------
// read
// ---------------------------------------------------------------------------
export function getReceiveParcels() {
  if (!DEMO_ENABLED) return [];
  return load();
}

export function getReceiveParcel(id) {
  if (!DEMO_ENABLED) return null;
  return load().find((c) => String(c.id) === String(id)) || null;
}

// ຄົ້ນຫາ / ກັ່ນຕອງ ຝັ່ງ client (ຈຳລອງ query param ຂອງ API)
export function filterReceiveParcels(params = {}) {
  const { search, status, start_branch, end_branch, start_date, end_date } = params;
  const kw = (search || "").trim().toLowerCase();

  return getReceiveParcels().filter((item) => {
    if (kw && !`${item.parcel_number} ${item.receiver?.name || ""}`.toLowerCase().includes(kw)) return false;
    if (status && item.status !== status) return false;
    if (start_branch && item.start_branch?.name !== start_branch) return false;
    if (end_branch && item.end_branch?.name !== end_branch) return false;
    if (start_date && item.created_at.slice(0, 10) < start_date) return false;
    if (end_date && item.created_at.slice(0, 10) > end_date) return false;
    return true;
  });
}

// ລາຍຊື່ສາຂາທີ່ມີໃນຂໍ້ມູນ (ໃຊ້ເຕີມ dropdown ກັ່ນຕອງ)
export function getBranchOptions(key) {
  const names = getReceiveParcels().map((i) => i[key]?.name).filter(Boolean);
  return [...new Set(names)].sort();
}

// ສະຫຼຸບຈຳນວນຕາມສະຖານະ (ໃຊ້ກັບ summary card ດ້ານເທິງ)
export function getStatusSummary() {
  const list = getReceiveParcels();
  return RECEIVE_STATUSES.map((s) => ({
    ...s,
    count: list.filter((i) => i.status === s.id).length,
  }));
}

// ---------------------------------------------------------------------------
// actions (mutate + persist)
// ---------------------------------------------------------------------------
function mutate(id, fn) {
  const list = load();
  const idx = list.findIndex((c) => String(c.id) === String(id));
  if (idx === -1) return null;
  const updated = fn({ ...list[idx] }) || list[idx];
  list[idx] = updated;
  save(list);
  return updated;
}

export function confirmReceive(id, byName) {
  return mutate(id, (item) => {
    item.status = "confirmed";
    item.confirmed_at = new Date().toISOString();
    item.rejected_at = null;
    item.reject_reason = null;
    item.confirmed_by = { name: byName || "Admin" };
    return item;
  });
}

export function rejectReceive(id, reason, byName) {
  return mutate(id, (item) => {
    item.status = "rejected";
    item.rejected_at = new Date().toISOString();
    item.confirmed_at = null;
    item.reject_reason = reason || "—";
    item.confirmed_by = { name: byName || "Admin" };
    return item;
  });
}
